import { useEffect, useState } from 'react'
import {Search, X} from 'lucide-react'
import { Link } from 'react-router-dom'
import { searchContent } from '@/lib/search'
import type { SearchResult } from '@/lib/search'

interface SearchModalProps {
  open: boolean
  onClose: () => void
}

function SearchModal({ open, onClose }: SearchModalProps) {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState<SearchResult[]>([])

  useEffect(() => {
    setResults(searchContent(query))
  }, [query])

  useEffect(() => {
    if (!open) {
      setQuery('')
      setResults([])
    }
  }, [open])

  if (!open)
    return null

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center bg-slate-950/60 px-4 pt-24 backdrop-blur-sm" role="dialog" aria-modal="true" aria-label="Buscar conteúdo">
      <div className="w-full max-w-xl rounded-2xl bg-white shadow-2xl">
        <div className="flex items-center gap-3 border-b border-slate-200 px-5 py-4">
          <Search className="h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" />
          <input
            autoFocus
            type="text"
            value={query}
            onChange={e => setQuery(e.target.value)}
            placeholder="Buscar serviços, projetos, artigos..."
            className="w-full border-none text-base text-slate-900 outline-none placeholder:text-slate-400"
          />
          <button type="button" onClick={onClose} aria-label="Fechar busca" className="rounded-full p-1 text-slate-400 hover:bg-slate-100 hover:text-slate-600">
            <X className="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
        <div className="max-h-96 overflow-y-auto p-2">
          {query.trim() && results.length === 0 ? (
            <p className="px-4 py-6 text-center text-sm text-slate-500">Nenhum resultado encontrado.</p>
          ) : null}
          {results.map(result => (
            <Link
              key={result.id}
              to={result.url}
              onClick={onClose}
              className="block rounded-xl px-4 py-3 hover:bg-slate-50"
            >
              <div className="flex items-center justify-between gap-3">
                <span className="text-sm font-semibold text-slate-900">{result.title}</span>
                <span className="shrink-0 rounded-full bg-cyan-50 px-2 py-0.5 text-[11px] font-medium text-cyan-700">{result.type}</span>
              </div>
              <p className="mt-1 line-clamp-1 text-xs text-slate-500">{result.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default SearchModal
